<template>
  <div id="layout">
    <nav class="d-flex d-flex-initial justify-center">
      <img
        class="hidden-screen-only"
        src="../../assets/hil-logo.png"
        alt="HiL"
        style="height: 80px; cursor: pointer"
      />
    </nav>
    <nav class="top-nav hidden-print-only">
      <v-toolbar dense color="primary">
        <v-btn :to="backProjectUrl" icon depressed active-class="dummy">
          <v-icon
            class="ml-1"
            size="22px"
            v-if="title === 'Mon compte' || title === 'Proposition'"
            color="white"
            >arrow_left</v-icon
          >
          <img
            src="../../assets/hil-logo.png"
            alt="HiL"
            style="height: 40px; cursor: pointer"
            class="mr-1"
          />
        </v-btn>
        <h2 class="ml-3 white--text app-title">
          {{ title || "Home In Love" }}
        </h2>
        <v-spacer></v-spacer>
        <v-btn
          :to="title === 'Mon compte' ? backProjectUrl : '/account'"
          round
          small
          icon
        >
          <v-icon color="white">account_circle</v-icon>
        </v-btn>
        <v-btn round small icon @click="logout">
          <v-icon color="accent">exit_to_app</v-icon>
        </v-btn>
      </v-toolbar>
    </nav>
    <ProjectStarter v-if="shouldDisplayInformationPopup" />
    <v-bottom-nav
      class="hidden-print-only"
      color="accent"
      fixed
      dark
      :value="projectInUrl"
    >
      <v-btn dark :to="`${projectPrefixUrl}`">
        <span>Suivi</span>
        <v-badge left color="red" :value="projectNotifsCount > 0">
          <template v-slot:badge>
            <span>{{ projectNotifsCount }}</span>
          </template>
          <v-icon>dashboard</v-icon>
        </v-badge>
      </v-btn>

      <v-btn dark :to="`${projectPrefixUrl}/edit`">
        <span>Mon projet</span>
        <v-icon>work</v-icon>
      </v-btn>

      <v-btn dark :to="`${projectPrefixUrl}/documents`">
        <span>Documents</span>
        <v-icon>folder_shared</v-icon>
      </v-btn>

      <v-btn dark :to="`${projectPrefixUrl}/proposals`">
        <span>Biens</span>
        <v-badge left color="red" :value="proposalNotifsCount > 0">
          <template v-slot:badge>
            <span>{{ proposalNotifsCount }}</span>
          </template>
          <v-icon>list</v-icon>
        </v-badge>
      </v-btn>
    </v-bottom-nav>
    <div v-if="!loading">
      <slot />
    </div>
    <div v-else>....</div>
  </div>
</template>

<script>
import ProjectStarter from "@/components/project/ProjectStarter.vue";

export default {
  name: "default-layout",
  components: { ProjectStarter },
  data: function () {
    return {
      loading: true,
      shouldDisplayInformationPopup: false,
    };
  },
  timers: {
    fetchNotifs: { time: 10000, autostart: true, repeat: true },
  },
  methods: {
    goto(name) {
      this.$router.push(name);
    },

    async logout() {
      try {
        await this.$store.dispatch("logout");
      } catch (e) {}

      window.location.href = "/";
    },

    async fetchNotifs() {
      await this.$store.dispatch("fetchNotifications", {
        ...this.$store.state.user,
      });
    },
  },
  watch: {
    currentProject: {
      handler(newProject, oldProject) {
        if (
          newProject &&
          oldProject === null && // Only trigger the 1st time the project initialized
          (!newProject.serviceWish ||
            !newProject.contractType ||
            !newProject.dateMove ||
            !newProject.moveWish)
        ) {
          this.shouldDisplayInformationPopup = true;
        }
      },
    },
  },
  async mounted() {
    await this.$store.dispatch("fetchStatus");
    this.loading = false;
    if (!this.isLogged) {
      this.$router.push({
        name: "home",
        params: { prevRoute: window.location.pathname },
      });
      return;
    }
    let id = this.$route.params.lease_id || this.$store.state.user.projectId;
    if (id != null) {
      await this.$store.dispatch("fetchProject", { id });
      if (!this.$store.state.currentProject) {
        this.$router.push("/");
        return;
      }
    }
    this.$store.dispatch("fetchNotifications", { ...this.$store.state.user });
  },
  computed: {
    projectInUrl() {
      return this.$route.params.lease_id != null;
    },
    backProjectUrl() {
      if (this.$store.state.user.projectId != null) {
        const projectUrl = `/leases/project/${this.$store.state.user.projectId}`;
        if (this.title === "Proposition") {
          return `${projectUrl}/proposals`;
        } else {
          return projectUrl;
        }
      } else {
        // return "/create-project";
        return "/";
      }
    },
    isLogged() {
      return this.$store.state.user.isLogged;
    },
    title() {
      return this.$route.meta.title;
    },
    currentTab() {
      return this.$route.meta.tab;
    },
    currentProject() {
      return this.$store.state.currentProject;
    },
    projectPrefixUrl() {
      return `/leases/project/${this.$store.state.currentProject?._id}`;
    },
    projectNotifsCount() {
      return this.$store.state.notifications.filter(
        ({ idEstate, idProject, seen }) =>
          idEstate == null && idProject === this.$route.params.lease_id && !seen
      ).length;
    },
    proposalNotifsCount() {
      return this.$store.state.notifications.filter(
        ({ idEstate, idProject, seen }) =>
          idEstate != null && idProject === this.$route.params.lease_id && !seen
      ).length;
    },
  },
};
</script>
<style>
#layout {
  min-height: 100vh;
  position: relative;
}
.app-title {
  font-size: 14pt;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
